import { externalFontFiles } from './externalFontFiles';
import { isLocalFont } from './isLocalFont';
const formats = ['Woff2', 'Woff'];
/**
 * Converts a font configuration to an external URL (on a CDN or other web server).
 */
export const fontToSource = ({ family, fileName }, cdnUrl) => {
    if (isLocalFont(family)) {
        return `local('${String(family)}')`;
    }
    const fontFiles = externalFontFiles(cdnUrl);
    return formats
        .map((format) => {
        const fontReferenceName = `${String(fileName)}${format}`;
        const url = fontFiles[fontReferenceName];
        if (!url) {
            if (cdnUrl) {
                throw new Error(`Unable to load external font: "${fontReferenceName}" from ${cdnUrl}.`);
            }
            throw new Error(`Unable to load bundled font: "${fontReferenceName}".`);
        }
        return `url('${url}') format('${format.toLowerCase()}')`;
    })
        .join(',');
};
//# sourceMappingURL=fontToSource.js.map